import { render, staticRenderFns } from "./ComponentList.vue?vue&type=template&id=3b3977bc"
import script from "./ComponentList.vue?vue&type=script&lang=js"
export * from "./ComponentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports